import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["as", "children", "className"];
import React, { forwardRef } from 'react';
import cx from 'classnames';
import Base from '../Base';
import styles from './index.module.scss';
var SYSTEM_PROPS = [];
var HtmlContent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Base, _extends({
    as: as,
    className: cx(styles.root, className),
    ref: ref
  }, props), children);
});
HtmlContent.displayName = 'HtmlContent';
HtmlContent.identifier = HtmlContent.displayName; // used in docs website

HtmlContent.clonableProps = SYSTEM_PROPS;
HtmlContent.defaultProps = {
  as: 'div'
};
export default HtmlContent;